
import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'
import store from '@/store'

export default {
  /**
  * 提款记录列表
  * @param {string} cbCstNo  用户session_customerId
  * @param {string} purchaseOrder 销售订单号码
  * @param {string} itemEm 商品名称
  * @param {string} beginApplyTime 提款发起时间
  * @param {string} endApplyTime
  * @param {string} minAmount 提款申请金额
  * @param {string} maxAmount
  * @param {string} minRespRmbAmount 到账人民币金额
  * @param {string} maxRespRmbAmount
  * @param {string} status  提款状态
  */
  settleRecordsList (params = {}, config = { convertPageNumAndSize: true }) {
    return api.post('/api/settlement/order/list', params, config, 'URLEncoded')
  },
  /**
   * 收款人信息查询
   * @param {*} cbCstNo 用户session_customerId
   */
  userList (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/list?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },

  /**
   * 收款人信息详情
   * @param {*} settlementUserInfoId id
   */
  userDetails (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/detail?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * 收款人信息重新提交
   * @param {string} cbCstNo 客户号
   * @param {string} cbCstName 姓名
   * @param {string} idCardNo 身份证
   * @param {string} bankCode 银行code
   * @param {string} bankCodeName 银行名称
   * @param {string} bankCardNo 银行卡号
   * @param {string} bankCardPhoneNo 手机号
   * @param {string} businessName 企业名称
   * @param {string} creditCode 统一社会信用代码
   * @param {array} licenseFiles 营业执照照片
   * @param {array} auditFiles 董事会决议
   */
  reCommit (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/reCommit?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * 收款人信息新增-多ubo
   * @param {string} cbCstNo 客户号
   * @param {string} cbCstName 姓名
   * @param {string} idCardNo 身份证
   * @param {string} bankCode 银行code
   * @param {string} bankCodeName 银行名称
   * @param {string} bankCardNo 银行卡号
   * @param {string} bankCardPhoneNo 手机号
   * @param {string} businessName 企业名称
   * @param {string} creditCode 统一社会信用代码
   * @param {array} licenseFiles 营业执照照片
   * @param {array} auditFiles 董事会决议
   */
  userAdd (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/add?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * 更新银行信息
   * @param {string} cbCstNo 客户号
   * @param {string} cbCstName 姓名
   * @param {string} idCardNo 身份证
   * @param {string} bankCode 银行code
   * @param {string} bankCodeName 银行名称
   * @param {string} bankCardNo 银行卡号
   * @param {string} bankCardPhoneNo 手机号
   * @param {string} businessName 企业名称
   * @param {string} creditCode 统一社会信用代码
   * @param {array} licenseFiles 营业执照照片
   * @param {array} auditFiles 董事会决议
   */
  modifyBankCard (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/modifyBankCard?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  },
  /**
   * 银行列表
   */
  listBankCodeInfo (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + '/api/settlement/user/listBankCodeInfo', params, config, 'URLEncoded')
  },
  /**
   * 验证是否为单一ubo
   * @param {*} cbCstNo 用户session_customerId
   */
  singleUBOCheck (params = {}, config = {}) {
    return api.post(NO_PREFIX_URL + `/api/settlement/user/singleUBOCheck?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config)
  }

}
